import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";
import matchupStyles from "../styles/matchups.css?url";
import { shellFrom } from "../lib/head";
import { loadMatchups } from "../server/matchups";

/**
 * The Matchups feature: its library's discovery list and heading load once and stay while
 * visitors move between the library and guides. They hold no coaching, for any audience.
 */
export const Route = createFileRoute("/matchups")({
  loader: async () => {
    const matchups = await loadMatchups();
    if (!matchups) throw notFound();
    return matchups;
  },
  staleTime: Infinity,
  gcTime: 30 * 60_000,
  shouldReload: false,
  head: ({ matches }) => ({
    links: [
      // After the themes, as production served Matchups' styles.
      { rel: "stylesheet", href: matchupStyles, precedence: "matchups" },
      // Matchups always set Inter, which a site with its own body face doesn't preload.
      ...(shellFrom(matches)?.fonts.body
        ? [
            {
              rel: "preload",
              href: "/_app/fonts/inter-variable.woff2",
              as: "font",
              type: "font/woff2",
              crossOrigin: "anonymous" as const,
            },
          ]
        : []),
    ],
  }),
  component: Outlet,
});
